
import lazyload from "@/directives/lazyload";
import Jessica from "@/assets/images/landing/img/Jessica.png";
import LisaA from "@/assets/images/landing/img/LisaA.png";
import SaraK from "@/assets/images/landing/img/SaraK.png";
import Kelly from "@/assets/images/landing/img/Kelly.png";
import EricJ from "@/assets/images/landing/img/EricJ.png";
import LogoAmerican from "@/assets/images/landing/svg/flag-american.svg";
export default {
  data() {
    return {
      stories: [
        {
          name: "Kelly V.",
          text:
            'He was so attentive, he noticed little things that made me feel right away like I was the center of his world. But then for a few days he just disappeared. He didn’t answer his phone or respond to texts or emails. When I asked him about that he apologized and said his work was really strict about personal calls and stuff. I don’t know why but my instincts told me something was going on. I did a <strong>Dating/Alternative Lifestyle Sites</strong> search with his email address. I’m not sure what I was expecting but it definitely was not what I discovered. He had profiles on two fetish sites as a submissive seeking dominant women. At first I was kind of freaked out but thinking about it made me curious and kind of excited.</br> On our next date I told him I thought he needed some discipline… He took my hand and looked at me like he was seeing me for the first time. He just opened up and since then I have discovered a whole new side of myself. In this case knowledge really was power!',
          imgMain: Kelly,
          imgSecond: LisaA,
          imgThird: Jessica,
          logo: LogoAmerican,
        },
        {
          name: "Lisa A.",
          text:
            'I was at his place and friends invited us out. He usually drives but getting in his car he realized he’d  forgotten his wallet. He left his phone on the car seat and ran back for it. The phone pinged and I glanced at it - it was a notification from a dating site. We’d been together a couple months so I was kind of shocked but didn’t want him to think I was nosey so I didn’t mention it then.</br> Driving back he could tell I was distracted so I told him. He laughed it off and said it was an old account he would disable. I tried to let it go but by the time we got back I knew I had to do something about my doubts. I told him I had to get up early the next day and went home.</br> I did scan of <strong>Dating/Alternative Lifestyle Sites</strong> that notifies you of new activity on existing accounts to see if he was telling the truth. He had three accounts, and there was new activity on all of them every day that week. At first I was insulted, then I got mad. Now, I am just relieved that I found out he’s a liar before I got too into him.',
          imgMain: LisaA,
          imgSecond: Jessica,
          imgThird: Kelly,
          logo: LogoAmerican,
        },
        {
          name: "Jessica K.",
          text:
            'I just had this feeling that something was going on. There had been a shift in the way he acted, it wasn’t something drastic, just different. I told my best friend about it and she suggested I check out what he was up to online. I felt weird about it at first but my sense that something had changed but not in a good way wasn’t going away. </br> I decided to do a <strong>Dating/Alternative Lifestyle Sites</strong> search on <strong>iFindCheaters</strong> and was super anxious. The trial shows you how it works and gives you results for some of the vanilla dating sites out there. He wasn’t on any of those, but I couldn’t deny my gut feeling. It cost less than lunch at a food truck to get the full report. </br> I was glad I did because my gut was right. He had active accounts on quite a few sites. If he was looking to meet other people there obviously was any point continuing to go out with him. At least now I know there is a way I can get info about potential boyfriends and protect myself!',
          imgMain: Jessica,
          imgSecond: Kelly,
          imgThird: LisaA,
          logo: LogoAmerican,
        },
      ],
      transitionClass: "list-next",
      pageNumber: 0,
    };
  },
  methods: {
    prevPage() {
      this.pageNumber--;
      this.transitionClass = "list-prev";
    },
    nextPage() {
      this.pageNumber++;
      this.transitionClass = "list-next";
    },
  },
  directives: {
    lazyload,
  },
};
